<app-panel-header-image-view pretitle="{{'Events' | transloco}}" title="{{'Results' | transloco}}" banner_image="../../../modules/custom/wa_angular/app/assets/images/banner.jpg"></app-panel-header-image-view>

<app-app-content-page-wrapper>
  <event-list-filter>
  </event-list-filter>
  <event-list-view>
  </event-list-view>
</app-app-content-page-wrapper>
